/**
 * Date-extensions locale siSwati [ss]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('ss', {
    monthNames: ['Bhimbidvwane', 'Indlovana', 'Indlov\'lenkhulu', 'Mabasa', 'Inkhwekhweti', 'Inhlaba', 'Kholwane', 'Ingci', 'Inyoni', 'Imphala', 'Lweti', 'Ingongoni'],
    monthShortNames: ['Bhi', 'Ina', 'Inu', 'Mab', 'Ink', 'Inh', 'Kho', 'Igc', 'Iny', 'Imp', 'Lwe', 'Igo'],
    dayNames: ['Lisontfo', 'Umsombuluko', 'Lesibili', 'Lesitsatfu', 'Lesine', 'Lesihlanu', 'Umgcibelo'],
    dayShortNames: ['Lis', 'Umb', 'Lsb', 'Les', 'Lsi', 'Lsh', 'Umg']
});
